import { render } from "./StagePopup.vue?vue&type=template&id=3ce882f0&scoped=true"
import script from "./StagePopup.vue?vue&type=script&lang=js"
export * from "./StagePopup.vue?vue&type=script&lang=js"

import "./StagePopup.vue?vue&type=style&index=0&id=3ce882f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\giragwe\\Documents\\Github\\2022-PO-JER-GoogleMars\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce882f0"]])

export default __exports__